import React from 'react';
import { shallowEqual } from 'react-redux';
import { Heading, Flex } from '@apia/theme';
import IProperty from '../../../../JSApi/constants/IProperty';
import usePropsSelector from '../../../../store/propsStore/usePropsSelector';
import { useApiaComponentContext } from '../apiaComponent/ApiaComponentContext';
import MakeField from '../fieldsStore/MakeField';
import useApiaFieldCommonProps from './useApiaFieldCommonProps';

const ApiaTitle = MakeField(
  React.forwardRef(() => {
    const { fieldId } = useApiaComponentContext();
    const props = usePropsSelector(
      fieldId,
      (cp) => ({
        [IProperty.PROPERTY_VALUE]: cp[IProperty.PROPERTY_VALUE],
        [IProperty.PROPERTY_FONT_COLOR]: cp[IProperty.PROPERTY_FONT_COLOR],
      }),
      shallowEqual,
    );

    const getValue = (val: unknown): string => {
      if (typeof val === 'string') {
        return val;
      }
      return '';
    };

    const { identifier } = useApiaFieldCommonProps({
      className: 'title__field',
    });
    return (
      <Flex
        sx={{
          alignItems: 'flex-end',
          height: '100%',
        }}
        {...window.getVariant('layout.execution.components.title')}
      >
        <Heading
          as="h3"
          title={getValue(props[IProperty.PROPERTY_VALUE])}
          sx={{
            my: '0',
            color: props[IProperty.PROPERTY_FONT_COLOR],
          }}
          {...identifier}
        >
          {getValue(props[IProperty.PROPERTY_VALUE])}
        </Heading>
      </Flex>
    );
  }),
  {
    preSynchronize() {
      return 'cancel';
    },
    doSynchronize() {
      return true;
    },
    doValidate() {
      return true;
    },
  },
);

export default ApiaTitle;
